import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CheckedOption } from '@app-shared/utils';
import latineze from 'latinize';

@Component({
    selector: 'app-checkbox-select-filter',
    templateUrl: './checkbox-select-filter.component.html',
    styleUrls: ['./checkbox-select-filter.component.scss'],
    standalone: false
})
export class CheckboxSelectFilterComponent implements OnInit {
	@Input()
	subAreasOptions: CheckedOption[] = [];

	@Input()
	enableScroll? = false;

	@Input()
	attrLabel? = 'name';

	@Input()
	checkBoxAll? = false;

	@Input()
	allSelect? = false;

	@Input()
	placeholder? = 'Digite para pesquisar...';

	@Output()
	selectEvt = new EventEmitter<any>();

	@Input()
	allPhase? = 'Todos';

	@Input()
	onlyView? = false;

	@Input()
	hideSelected? = false;

	searchWord;

	renderList: CheckedOption[] = [];

	@Input()
	filterFunction? = (arr: CheckedOption[], word: string, attrSearch) => {
		if (word == undefined || word.length <= 0) {
			return arr;
		}
		return arr.filter(i => {
			if (i.option !== undefined && i.option[attrSearch] !== undefined) {
				const palavra = latineze(i.option[attrSearch]) as string;
				if (palavra.toLowerCase().indexOf(word.toLowerCase()) > -1) {
					return true;
				}
			}
			return false;
		});
	};

	constructor() {}

	ngOnInit() {}

	updateRenderList(list: CheckedOption[]) {
		this.renderList = list;
	}

	emit(event) {
		this.selectEvt.emit(event);
	}
	keyUp(event) {
		// atualizar sa lista de render conforme o que foi digitado
		this.renderList = this.filterFunction(

    this.subAreasOptions,
    this.searchWord,
    this.attrLabel);
	}
}
